interface Props {
  initials: string;
  size?: number;
  tint?: number;
  src?: string | null;
}

const TINTS = [
  "linear-gradient(135deg,#FF5A1F,#FFB800)",
  "linear-gradient(135deg,#1E7A5A,#6AB3F3)",
  "linear-gradient(135deg,#0E1116,#707579)",
  "linear-gradient(135deg,#FF5A1F,#DF3F40)",
  "linear-gradient(135deg,#2481CC,#6AB3F3)",
  "linear-gradient(135deg,#FFB800,#FF5A1F)",
];

export function Avatar({ initials, size = 40, tint = 0, src }: Props) {
  if (src) {
    return (
      <img
        src={src}
        alt={initials}
        width={size}
        height={size}
        style={{ width: size, height: size, borderRadius: "50%", objectFit: "cover", flex: "none" }}
      />
    );
  }

  return (
    <div
      aria-label={initials}
      style={{
        width: size,
        height: size,
        borderRadius: 999,
        background: TINTS[tint % TINTS.length],
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "var(--font-body)",
        fontWeight: 700,
        fontSize: Math.round(size * 0.36),
        flex: "none",
        userSelect: "none",
      }}
    >
      {initials}
    </div>
  );
}

/** Deterministic initials from a user's first / last / username. */
export function getInitials(first?: string | null, last?: string | null, fallback?: string | null): string {
  const a = (first ?? "").trim()[0] ?? "";
  const b = (last ?? "").trim()[0] ?? "";
  const combined = `${a}${b}`.toUpperCase();
  if (combined) return combined;
  const fb = (fallback ?? "").trim();
  return fb ? fb[0]!.toUpperCase() : "?";
}

/** Stable tint index from a user id. */
export function tintForId(id: number): number {
  return Math.abs(id) % TINTS.length;
}
